import { getAuthHeader } from "./authService";

/** Dato quemado (institución) — NO cambiar */
export const INSTITUCION_ID = "16020324-f0ea-4319-905c-5a30618ce9f5";

/** Base URL del backend */
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/partidos`;

/* ========== Helpers ========== */
const toJson = (res) => res.json().catch(() => ({}));

const ensureOk = (res, data) => {
    if (!res.ok) {
        const msg =
            data?.message ||
            data?.error ||
            (typeof data === "string" ? data : "") ||
            `HTTP ${res.status}`;
        throw new Error(msg);
    }
};

/**
 * GET - Obtener partidos. Si se pasa institucionId se envía como query string.
 * Endpoint del servidor espera ?institucionId=123
 * @param {string} [institucionId]
 * @returns {Promise<Array>} Lista de partidos
 */
export async function getPartidos() {
    const res = await fetch(`${BASE_URL}/${INSTITUCION_ID}`, {
        headers: { Accept: "application/json", ...getAuthHeader() },
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? [];
}

/**
 * POST - Crear un nuevo partido.
 * Nota: la API incluye :institucionId en la ruta pero el controlador espera
 * el campo institucion_id en el body. Aquí usamos la ruta con el institucion_id
 * si está disponible en el body para mantener compatibilidad.
 * @param {Object} partidoData - Datos del partido (debe incluir institucion_id)
 * @returns {Promise<Object>} Partido creado
 */
export async function createPartido(partidoData) {
    if (!partidoData) {
        throw new Error("Los datos del partido son requeridos");
    }

    const res = await fetch(`${BASE_URL}/${INSTITUCION_ID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...getAuthHeader(),
        },
        body: JSON.stringify(partidoData),
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? {};
}

/**
 * PUT - Actualizar un partido por id
 * @param {string|number} id - ID del partido a actualizar
 * @param {Object} partidoData - Campos a actualizar
 * @returns {Promise<Object>} Partido actualizado
 */
export async function updatePartido(id, partidoData) {
    if (!id) {
        throw new Error("El ID del partido es requerido");
    }
    const res = await fetch(`${BASE_URL}/${id}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...getAuthHeader(),
        },
        body: JSON.stringify(partidoData),
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data?.data ?? {};
}

/**
 * DELETE - Eliminar un partido por id
 * @param {string|number} id - ID del partido a eliminar
 * @returns {Promise<Object>} Resultado de la eliminación
 */
export async function deletePartido(id) {
    if (!id) {
        throw new Error("El ID del partido es requerido");
    }
    const res = await fetch(`${BASE_URL}/${id}`, {
        method: "DELETE",
        headers: { Accept: "application/json", ...getAuthHeader() },
    });
    const data = await toJson(res);
    ensureOk(res, data);
    return data ?? {};
}